import { fg } from '@atlassian/jira-feature-gating';
import { NORMAL_EARLY_ASSET_STRATEGY } from '@atlassian/jira-common-constants/src/ssr-early-assets.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { helpCenterSettingsAgentStudioHandoffRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsAgentStudioHandoffRoute.tsx';
import { agentStudioNavigation } from './common/constants.tsx';
import { csmAgentHandoffPageEntryPoint } from './ui/agent-studio/index.tsx';

export const helpCenterSettingsAgentStudioHandoffRouteEntry = createEntry(
	helpCenterSettingsAgentStudioHandoffRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.agent-studio-handoff',
		component: ErrorPagesNotFound,
		entryPoint() {
			return fg('csm_ai_agent_builder_handoff') ? csmAgentHandoffPageEntryPoint : undefined;
		},
		layout: serviceProjectLayout,
		navigation: agentStudioNavigation,
		resources: [...getServiceDeskSettingsResources()],
		earlyAssets: NORMAL_EARLY_ASSET_STRATEGY,
	}),
);
